import { collection, deleteDoc, doc, getDocs, writeBatch } from "firebase/firestore";
import { db } from "./firebase";

// Firestore never deletes a document's subcollections along with it — a
// calendarEvents/{id} or todos/{id} doc owns a "comments" subcollection
// (see CalendarEventComment/TodoComment in types.ts) that would otherwise
// be left behind forever, invisible anywhere in the UI, every time the
// parent gets deleted. Same batch-delete-then-delete-parent shape already
// used for lists/items (ListDetail.tsx) and linkBoards/links
// (LinkBoardDetail.tsx) — this only ever touches comments that belong to
// the one event/todo being deleted in this same action, never anything else.
async function deleteWithComments(
  coupleId: string,
  parentCollection: "calendarEvents" | "todos",
  id: string
): Promise<void> {
  const commentsSnap = await getDocs(collection(db, "couples", coupleId, parentCollection, id, "comments"));
  for (let i = 0; i < commentsSnap.docs.length; i += 450) {
    const batch = writeBatch(db);
    for (const c of commentsSnap.docs.slice(i, i + 450)) {
      batch.delete(doc(db, "couples", coupleId, parentCollection, id, "comments", c.id));
    }
    await batch.commit();
  }
  await deleteDoc(doc(db, "couples", coupleId, parentCollection, id));
}

export async function deleteCalendarEvent(coupleId: string, eventId: string): Promise<void> {
  await deleteWithComments(coupleId, "calendarEvents", eventId);
}

export async function deleteTodo(coupleId: string, todoId: string): Promise<void> {
  await deleteWithComments(coupleId, "todos", todoId);
}
